import React, { useEffect, useState } from "react";
import { FlapDisplay, Presets } from "react-split-flap-effect";
import "./timecounter.css";
import { useLanguage } from "../../context/LanguageContext";

const TimeCounter = () => {
  const { t, changeLanguage } = useLanguage();
  const [elapsedTime, setElapsedTime] = useState("");

  useEffect(() => {
    const startDate = new Date("2023-11-01T12:00:00Z");
    const interval = setInterval(() => {
      const now = new Date();

      const yearsDiff = now.getFullYear() - startDate.getFullYear();
      const monthsDiff = now.getMonth() - startDate.getMonth();

      let totalMonths = yearsDiff * 12 + monthsDiff;
      const tempDate = new Date(startDate);
      tempDate.setMonth(tempDate.getMonth() + totalMonths);

      if (tempDate > now) {
        totalMonths -= 1;
        tempDate.setMonth(tempDate.getMonth() - 1);
      }

      const diff = now - tempDate;
      const seconds = Math.floor((diff / 1000) % 60);
      const minutes = Math.floor((diff / (1000 * 60)) % 60);
      const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));

      const formattedTime = `${totalMonths.toString().padStart(2, '0')} ${days.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')} ${minutes.toString().padStart(2, '0')} ${seconds.toString().padStart(2, '0')}`;

      setElapsedTime(formattedTime);
    }, 1000);


    return () => clearInterval(interval);
  }, []);

  return (
    <div className="time-counter-container">
      <div className="flap-display-container">
        <FlapDisplay
          chars={Presets.ALPHANUM}
          value={elapsedTime}
          padChar=" "
          className="flap-display"
        />
      </div>
      <div className="time-labels">
        <span>{t("month")}</span>
        <span>{t("day")}</span>
        <span>{t("hour")}</span>
        <span>{t("minute")}</span>
        <span>{t("second")}</span>
      </div>
    </div>
  );
};

export default TimeCounter;
